/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import applySocketUpdates from 'modules/state/apply-socket-updates';
import createStore from './store';

export const defaultStore = createStore([applySocketUpdates]);



// WEBPACK FOOTER //
// ./app/gamma/src/defaultStore.ts